// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu__30KE","right":"right_6Pl1l","action":"action_kbHTR","account":"account_LMqiO","avatar":"avatar_2zl16","dark":"dark_12fxs"};